// extracted by mini-css-extract-plugin
export default {"root":"sAKVA","badge":"yH6ha","rate":"Vblbx","status":"DAYVl","title":"Jmk34","description":"cu8bp"};